/**
 * Translates a name based on a matching pattern.
 *
 * @param name - The name to translate, which should match the pattern.
 * @param path - The translation path prefix.
 * @param matcher1 - The first regular expression to match the name against.
 * @param matcher2 - The second regular expression to match the name against.
 * @param t
 */
// Common/useI18nTranslations.ts
type TFunc = (key: string, params?: Record<string, any>) => string;

export function translateMatchingPattern(
  input: string,
  baseKey: string, // e.g. "config.form"
  pairRegex: RegExp, // e.g. /^(realm|connection|mapping)\s+(.+)$/i
  simpleRegex: RegExp, // e.g. /^(settings|realm|connection|mapping|realms|connections|mappings)$/i
  t: TFunc = (k) => k
): string {
  const value = (input ?? '').trim();
  if (!value) return value;

  // "realm Foo" / "connection Bar" / "mapping Baz"
  const pair = value.match(pairRegex);
  if (pair) {
    const token = pair[1].toLowerCase(); // realm|connection|mapping
    const rest = pair[2];
    return t(`${baseKey}.${token}`, { [token]: rest });
  }

  // "settings", "connections", "realms", "mappings", etc.
  const single = value.match(simpleRegex);
  if (single) {
    const token = single[1].toLowerCase();
    return t(`${baseKey}.${token}`);
  }

  return value;
}
